<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      d="M8.13 7.16C10.32 7.16 12 8.82 12 10.84C12 10.95 11.91 11.03 11.81 11.03C8.24 11.03 3.98 11.03 0.19 11.03C0.09 11.03 0 10.95 0 10.84C0 8.74 1.77 7.16 3.87 7.16H8.13Z"
      :fill="active ? 'url(#user_blue)' : 'url(#user_gray)'"
    />
    <path
      d="M3.81 0.88C5 -0.26 6.81 -0.29 8.05 0.77L8.17 0.88L8.17 0.88L8.28 1C9.4 2.25 9.37 4.15 8.17 5.29C6.94 6.45 4.97 6.54 3.8 5.28C2.65 4.04 2.56 2.06 3.81 0.88Z"
      :fill="active ? 'url(#user_blue)' : 'url(#user_gray)'"
    />
    <defs>
      <linearGradient id="user_blue" x1="0.55" y1="9.65" x2="11.47" y2="2.54" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="user_gray" x1="0.55" y1="9.65" x2="11.47" y2="2.54" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
